<template lang="pug">
  div(class="qcw-comment__attachment")
    audio(
      v-if="fileType == 'audio' && !isBlacklistedFiles"
      :src="comment.payload.url"
      width="100%"
      controls) Your browser does not support the audio element.
    video(
      :controlsList="controlsListValue"
      controls
      v-if="fileType == 'video' && !isBlacklistedFiles"
      muted
      :src="videoSource"
      width="100%") Sorry, your browser doesn't support embedded videos.
    image-loader(
      v-else
      :comment="comment"
      :message="fileSource"
      :whitelisted-files="whitelistedFiles"
      :on-click-image="onClickImage"
      :thumbnailMode="true"
      :callback="callback"
      :isMe="isMe")

    comment-render(:text="comment.payload.caption" v-if="comment.payload.caption != '' && !isInteractiveMessage")

    //- USER COMMENT INSTAGRAM POST
    div(v-if="comment.extras && ( isInstagramSource || isRedownloadAttachment)"
      class="reply-wrapper" :class="{'reply-wrapper--redownload': isRedownloadAttachment}")
      comment-render(:text="comment.extras.reply" v-if="comment.extras.type !== 'redownload_attachment' && comment.extras.reply && comment.extras.reply !== ''")
      comment-redownload(message="This attachment file was sent in the previous message by " :sender="comment.extras.sender" :timestamp="comment.extras.timestamp" v-if="isRedownloadAttachment")
</template>

<script>
import ImageLoader from "./ImageLoader";
import CommentRender from "./CommentRender";
import CommentRedownload from "./CommentRedownload";
import Icon from "./Icon";

export default {
  name: "FileAttachment",
  components: { ImageLoader, CommentRender, Icon, CommentRedownload },
  props: ["comment", "whitelistedFiles", "onClickImage", "callback", "isMe"],
  data() {
    return {
      imageExts: ["jpg", "jpeg", "gif", "webp", "png"],
      videoExts: ["mov", "mp4", "webm"],
      audioExts: ["mp3", "oga", "ogg", "m4a"],
      ext: "",
      fileType: null,
      controlsListValue: ""
    };
  },
  computed: {
    isInteractiveMessage() {
      return (
        this.comment.extras &&
        this.comment.extras.type === "interactive_wa" &&
        this.comment.extras.sub_type === "reply_buttons"
      );
    },
    fileSource() {
      if (this.isInteractiveMessage) return this.comment.extras.header.value;
      return this.comment.message;
    },
    videoSource() {
      if (this.isInteractiveMessage) return this.comment.extras.header.value;
      return this.comment.payload.url;
    },
    isRedownloadAttachment() {
      return this.comment.extras.type === "redownload_attachment";
    },
    isInstagramSource() {
      return (
        this.comment.extras.type == "video_ig_comment" ||
        this.comment.extras.type == "image_ig_comment" ||
        this.comment.extras.type === "carousel_album_ig_comment"
      );
    },
    isBlacklistedFiles() {
      if (this.whitelistedFiles) {
        if (this.whitelistedFiles.length > 0)
          return !this.whitelistedFiles.includes(this.ext);
      }
      return false;
    }
  },
  mounted() {
    let payload;
    if (this.isInteractiveMessage && this.comment.extras.header) {
      payload = this.comment.extras.header;
    } else if (this.comment.payload && this.comment.payload.url) {
      payload = this.comment.payload;
    }

    if (payload) {
      this.fileType = this.checkfileType(payload);
    } else if (this.comment.message) {
      const splittedUri = this.comment.message.split(".");
      this.ext = splittedUri[splittedUri.length - 1]
        .replace(/\s|\[\/file\]/g, "")
        .toLowerCase();
      if (this.videoExts.includes(this.ext)) this.fileType = "video";
      if (this.audioExts.includes(this.ext)) return "audio";
    }
  },
  methods: {
    checkfileType(payload) {
      const extras = this.comment.extras;
      const isAudio = extras.source === "ig" && extras.type === "audio";
      const isVideo = extras.source === "ig" && extras.type === "video";
      const splittedURL = this.isInteractiveMessage
        ? payload.value.split(".")
        : payload.url.split(".");
      this.ext = splittedURL[splittedURL.length - 1].toLowerCase();
      if (this.imageExts.includes(this.ext)) return "image";
      if (this.videoExts.includes(this.ext) || isVideo) {
        const qismoRawData = localStorage["qismo-data"];
        if (qismoRawData) {
          const qismoData = JSON.parse(qismoRawData);
          const isAgent =
            qismoData && qismoData.user && qismoData.user.type === 2;
          const appConfig = window.appAdditionalConfig
            ? window.appAdditionalConfig
            : false;
          const agentCantDownload = !(
            appConfig && appConfig.agentCanDownloadVideo
          );
          if (isAgent && agentCantDownload) {
            this.controlsListValue = "nodownload";
          }
        }
        return "video";
      }
      if (this.audioExts.includes(this.ext) || isAudio) return "audio";
      if (extras.source === "ig") return "ic-ig-attachment";
      return "ic-file-attachment";
    }
  }
};
</script>

<style lang="stylus">
.qcw-comment__attachment
  video
    max-height 150px
    border-radius 16px

.qcw-comment__attachment > div > .qcw-comment__content
    margin-block 8px
</style>



// WEBPACK FOOTER //
// src/components/FileAttachment.vue